import {
  FETCH_LOGS_BEGIN,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAILURE,
} from "../actions/types";

const initialState = {
  logs: [],
  loading: false,
  error: null,
};

export default function project(state = initialState, action) {
  switch (action.type) {
    case FETCH_LOGS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        logs: action.payload,
      };
    case FETCH_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
